export const LoginTexts = {
	loginDescription:
		'Data Direct is your window to Northern Trust data in Excel. Please login to access your data.',
	loginProcessText: 'Please sign-in on the pop-up window.',
	logoutDescription:
		'Are you sure you want to sign out of Data Direct?',
	logoutProcessText: 'Please wait, sign-out is in progress!',
};
